import { ApiRequest } from '../../apiRequest'
import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import { getOrderCompleteApiUrl } from '../../../constants/apiUrls'
import { callOrderComplete, callOrderCompleteAsync } from '../../actions/app/orderComplete.actions'
import { createNotification } from '../../actions/app/notification.actions'

const orderCompleteMiddleware = (
    apiRequest: ApiRequest,
): Middleware => (store) => (next) => (action) => { /* eslint-disable-line consistent-return */
    next(action)
    const { dispatch } = store

    if (isActionOf(callOrderComplete, action)) {
        apiRequest(
            {
                options: {
                    url: getOrderCompleteApiUrl(),
                    method: 'GET',
                },
                asyncActions: {
                    request: callOrderCompleteAsync.request,
                    success: callOrderCompleteAsync.success,
                    failure: callOrderCompleteAsync.failure,
                },
                causedBy: action,
            },
            dispatch,
        )
    }

    if (isActionOf(callOrderCompleteAsync.failure, action)) {
        const message = action.payload.message !== "BAD_REQUEST" && action.payload.message !== "INTERNAL_SERVER_ERROR"
            ? action.payload.message
            : 'Error'
        dispatch(createNotification({
            type: 'error',
            message: message,
        }))
    }

}

export default orderCompleteMiddleware
